import { Card } from "@components/_Revamp/StyledComponent";
import { styled } from "@linaria/react";
import { css } from "@linaria/core";

import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { themeDefault } from "src/theme-revamp";
import Button from "../../Components/Button";
import Checkbox from "@pages/EverGreen/Components/Checkbox";

import Input from "@components/_Revamp/Input";
import { get, isEmpty } from "lodash";
import { EVERGREEN_API, getAddressWithPostalCode } from "@api/index";
import { useHistory } from "react-router";
import { ROUTE_PATH } from "@static/route-paths";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import {
  updateIsMailingAddressConfirmed,
  updateMailingAddressState,
} from "@redux/slices/EVER_GREEN/step2Slice";
import {
  QASPostalCodeRequest,
  QASPostalCodeResponse,
} from "@models/QASPostalCodeRequest";
import { Validations } from "@utils/helpers";
import { calculateSpacer } from "@utils/spaceCalculation";
import { scrollToRef } from "@utils/scrollScript";
import { Tooltip } from "@pages/EverGreen/Components/Tooltip";
import MainContainer from "@pages/EverGreen/Components/Container";
import { SCREEN_SIZE } from "@static/screen-size";
import { setLoadingState } from "@redux/slices/loadingSlice";
import Dropdown from "@pages/EverGreen/Components/Dropdown";
import { EverGreenStyle } from "@utils/Style/everGreen";
import { trackOnFormStartOrSuccess, trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";
// import { Nationalities } from "@static/nationalities";

const Header = styled.div<{ maxWidth?: string }>`
  font-size: 28px;
  max-width: 327px;
  margin: 0 auto;
  font-weight: 600;
  text-align: center;
  color: #434343;
  @media screen and (max-width: 767px) {
    font-size: 18px;
  }
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    white-space: break-spaces;
    max-width: 583px;
  }
`;

const SpiltUpContainer = styled.div<{ mariginTop?: string }>`
  max-width: 100%;
  display: flex;
  margin-top: ${(props) => props.mariginTop || "60px"};
  & div {
    width: 100%;
    flex-grow: 1;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 0px;
    & div {
      display: flex;
      flex-direction: column;
      width: auto;
      flex-grow: 1;
      column-gap: 15px;
    }
  }
`;

const cardStyle = css`
  align-items: unset;
  background-color: white;
  padding: 24px;
`;

const cardStyleUpdateMail = css`
  align-items: unset;
  margin-top: 0;
  padding: 24px;
`;

const hideSytle = css`
  display: none;
  opacity: 0;
  transition: opacity 0.2s ease-in;
`;

const FieldLable = styled.div`
  font-size: 14px;
`;

const FieldValue = styled.div`
  font-style: normal;
  line-height: 140%;
  color: #434343;
  margin-top: 16px;
  font-weight: 600;
  font-size: 14px;
  @media screen and (max-width: 767px) {
    margin-bottom: 32px;
    font-size: 14px;
  }
`;

const CardDescription = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  @media screen and (max-width: 767px) {
    margin-bottom: 36px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  justify-content: center;
  margin-top: 80px;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`;

const countryStyle = css`
  display: flex;
  width: 100%;
  height: 66px;
  gap: 24px;
  label {
    font-size: 12px;
  }
  &:nth-child(1) {
    & input {
      margin-top: 10px;
    }
  }
  @media screen and (max-width: 767px) {
    height: auto;
  }
`;

const postalCodeStyle = css`
  display: flex;
  width: 100%;
  height: 100%;
  gap: 24px;
  label {
    font-size: 12px;
  }
  &:nth-child(1) {
    & input {
      margin-top: 10px;
    }
  }
  @media screen and (max-width: 767px) {
    height: auto;
  }
`;
const postalCodeInputStyle = css`
  display: flex;
  height: 66px;
  align-items: flex-start;
  gap: 24px;

  label {
    font-size: 12px;
  }
  & > div {
    & input {
      margin-top: 10px;
    }
    width: 100%;
    & input {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 767px) {
    height: auto;
    & > div {
      margin-top: 22px;
    }
  }
`;

const unitNoCss = css`
  div:first-child {
    width: auto;
    flex-grow: unset;
  }
`;

const checkboxDifferentEmail = css`
  padding: 24px;
  display: block;
`;

const noteText = css`
  font-size: 12px;
  font-weight: 500;
  width: 100%;
  margin-top: 36px;
`;
const searchBtnCss = css`
  width: 100%;
  max-width: unset;
`;
const Disclaimer = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 500;
  margin-left: 5%;
  @media screen and (max-width: 767px) {
    margin-left: 38px;
    margin-top: 5px;
  }
`;

const InvalidPostCodeMsg = styled.p`
  color: #c50000;
  margin-top: 7px;
  font-weight: 600;
  font-size: 12px;
`;

const LooksGoodStyle = styled.button<{ disabled: boolean }>`
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 16px 60px;
  font-weight: 600;
  width: 282px;
  height: 52px;
  background: #0a544f;
  border-radius: 101px;
  align-items: center;
  text-align: center;
  transition: all 0.1s linear;
  color: #fff;
  font-size: 14px;
  cursor: ${(prop) => (prop.disabled ? "auto" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.25 : 1)};
`;

const UpdateEmailContainer = styled.div`
  border-radius: 8px;
`;

enum InputState {
  UPDATE_BLOCK_NUMBER,
  UPDATE_UNIT_NUMBER,
  UPDATE_STREET_NAME,
  UPDATE_POST_CODE,
  UPDATE_BUILDING_NAME,
  UPDATE_ADDRESS,
  UPDATE_MAIL_ADDRESS_FOR_ALL,
  UPDATE_ENTIRE_MAILADDRESS,
  UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE,
  UPDATE_COUNTRY_CODE,
}

function MailingAddress() {
  const [invalidPostalCode, setInvalidPostalCode] = useState("");
  const [isDirty, setIsDirty] = useState(false);
  const [isLooksGoodEnabled, setIsLooksGoodEnabled] = useState(false);
  const residentialAddress = useAvivaSelector(
    (state) => state.everGreenStep2.myInfo?.address
  );
  const mailingAddress = useAvivaSelector(
    (state) => state.everGreenStep2.myInfo?.mailingAddress
  );
  const isMyInfoSubmitted = useAvivaSelector(
    (state) => state.everGreenStep2.isMyInfoSumbitted
  );
  const dispatch = useAvivaDispatch();
  const history = useHistory();
  const [isInvalidUnitNo, setIsInvalidUnitNo] = useState(false);
  const [isInValidBlock, setIsInValidBlock] = useState(false);
  const [isInvalidStreet, setIsInvalidStreet] = useState(false);
  const mailingAddressUpdateFormRef = useRef<null | HTMLDivElement>(null);
  const mailingAddressOriginalFormRef = useRef<null | HTMLDivElement>(null);
  const [addressData, dispatchAddressAction] = useReducer(reducer, {
    block: "",
    unitNo: "",
    street: "",
    postal: "",
    building: "",
    country: "",
    useDifferentMailing: mailingAddress === null ? undefined : true,
    useMailAddressForAll: false,
    ...(mailingAddress || {}),
  });
  const maxPostCodeLength = addressData.country === "SG" ? 6 : 10;
  const myinfotransactionId = useAvivaSelector(
    (state) => state.everGreenStep2.myinfoTransactionId
  );
  const SpacerRef = useRef<null | HTMLDivElement>(null);
  const countryList = useAvivaSelector(
    (state) => state.everGreenStep1.staticData.countryList
  );
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const isSearched = useRef<boolean>(false);

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  async function updateMailingAddress() {
    //update the mailing address in Store and goto next page
    dispatch(setLoadingState(true));
    try {
      dispatch(
        updateMailingAddressState(
          addressData.useDifferentMailing ? addressData : null
        )
      );
      dispatch(updateIsMailingAddressConfirmed(true));
      trackOnFormStartOrSuccess("DS_mailingaddress_form",true)

      history.push(ROUTE_PATH.EVER_GREEN_OCCUPATION);
      dispatch(setLoadingState(false));
    } catch (error) {
      history.push(ROUTE_PATH.EVER_GREEN_SINGPASS);
      dispatch(setLoadingState(false));
    }
  }

  function noChangeMailingAddress() {
    setTimeout(() => {
      if (
        mailingAddressUpdateFormRef &&
        mailingAddressUpdateFormRef.current &&
        mailingAddressOriginalFormRef &&
        mailingAddressOriginalFormRef.current
      ) {
        let unit = -100;
        screenSize < SCREEN_SIZE.mobilesUp && (unit = 20);
        screenSize > SCREEN_SIZE.mobilesUp &&
          screenSize < SCREEN_SIZE.mobileSteper &&
          (unit = -136);

        const elementOffSetTop =
          mailingAddressOriginalFormRef.current.offsetTop;
        calculateSpacer(mailingAddressUpdateFormRef, SpacerRef, false);
        const top = window.pageYOffset || document.documentElement.scrollTop;
        scrollToRef(
          document.documentElement,
          "scrollTop",
          unit,
          top,
          elementOffSetTop,
          300,
          true,
          () => {
            if (mailingAddressUpdateFormRef.current) {
              mailingAddressUpdateFormRef.current.style.display = "none";
            }
          }
        );
        mailingAddressUpdateFormRef.current.style.opacity = "0.25";
        mailingAddressUpdateFormRef.current.style.pointerEvents = "none";
      }
    }, 100);
    //TODO Set the next page once it's created
    dispatch(updateMailingAddressState(null));
  }

  function setMailingForAll() {
    dispatchAddressAction({
      type: InputState.UPDATE_MAIL_ADDRESS_FOR_ALL,
      useMailAddressForAll: !addressData.useMailAddressForAll,
    });
  }
  const scrollToUpdateMail = useCallback(() => {
    setTimeout(() => {
      if (mailingAddressUpdateFormRef && mailingAddressUpdateFormRef.current) {
        mailingAddressUpdateFormRef.current.style.display = "block";
        let unit = -100;
        screenSize < SCREEN_SIZE.mobilesUp && (unit = 20);
        screenSize > SCREEN_SIZE.mobilesUp &&
          screenSize < SCREEN_SIZE.mobileSteper &&
          (unit = -136);

        const elementOffSetTop = mailingAddressUpdateFormRef.current.offsetTop;
        calculateSpacer(mailingAddressUpdateFormRef, SpacerRef, false);
        const top = window.pageYOffset || document.documentElement.scrollTop;
        scrollToRef(
          document.documentElement,
          "scrollTop",
          unit,
          top,
          elementOffSetTop,
          300,
          true
        );
        mailingAddressUpdateFormRef.current.style.opacity = "1";
        mailingAddressUpdateFormRef.current.style.pointerEvents = "auto";
      }
    }, 500);
  }, [screenSize]);
  function reducer(state: any, payload: any) {
    switch (payload.type) {
      case InputState.UPDATE_ADDRESS: {
        if (!isDirty) {
          setIsDirty(true);
        }
        return { ...state, ...payload?.address };
      }
      case InputState.UPDATE_BLOCK_NUMBER: {
        return { ...state, block: payload?.block };
      }
      case InputState.UPDATE_UNIT_NUMBER: {
        return { ...state, unitNo: payload?.unitNo };
      }
      case InputState.UPDATE_STREET_NAME: {
        return { ...state, street: payload?.street };
      }
      case InputState.UPDATE_POST_CODE: {
        return { ...state, postal: payload?.postal };
      }
      case InputState.UPDATE_BUILDING_NAME: {
        return { ...state, building: payload?.building };
      }
      case InputState.UPDATE_MAIL_ADDRESS_FOR_ALL: {
        return { ...state, useMailAddressForAll: payload.useMailAddressForAll };
      }
      case InputState.UPDATE_ENTIRE_MAILADDRESS: {
        return { ...state, useDifferentMailing: payload.useDifferentMailing };
      }
      case InputState.UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE: {
        return { ...state, ...payload.mailingaddress };
      }
      case InputState.UPDATE_COUNTRY_CODE: {
        return { ...state, country: payload.country };
      }
      default:
        return state;
    }
  }

  const validatePostCode = useCallback(() => {
    if (addressData?.country === "SG" && !isSearched.current) return;
    if (addressData.country === "SG" && !/[0-9]{6}/.test(addressData.postal)) {
      setInvalidPostalCode("Please enter a valid postal code");
    } else if (addressData.postal.toString().length < 4) {
      setInvalidPostalCode("Please enter a valid postal code");
    } else {
      setInvalidPostalCode("");
    }
  }, [addressData.country, addressData.postal]);

  function setPostalCodeValue(value: string) {
    if (invalidPostalCode) {
      setInvalidPostalCode("");
    }
    //TODO: Check with business if changing the postal code needs to erase all the fields
    // dispatchAddressAction({
    //   type: InputState.UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE,
    //   mailingaddress: {
    //     block: "",
    //     unitNo: "",
    //     street: "",
    //     postal: "",
    //     building: ""
    //   },
    // });
    dispatchAddressAction({
      type: InputState.UPDATE_POST_CODE,
      postal: value,
    });
  }

  async function fetchAddressWithPostalCode() {
    // trackOnStart("search_postal_code")
    trackOnFormStartOrSuccess("DS_mailingaddress_form")

    let zipcode = addressData.postal;
    const payload = new QASPostalCodeRequest({
      postalCode: zipcode,
      country: addressData.country,
    });
    try {
      const response = await getAddressWithPostalCode(
        payload,
        EVERGREEN_API.ADDRESS
      );
      const data = get(response, "data");
      if (!data.valid) {
        setInvalidPostalCode(
          "We couldn't find your postal code. Enter your address below."
        );
        return;
      }
      const address = new QASPostalCodeResponse(data);
      const unit = get(address, "addressLine3", undefined);
      let addressRestructured = {
        block: get(address, "addressLine1", ""),
        unitNo: isEmpty(unit) ? undefined : unit,
        street: get(address, "addressLine2", ""),
        building: get(address, "addressLine4", ""),
        postal: zipcode,
        useDifferentMailing: true,
      };

      isSearched.current = true;
      dispatchAddressAction({
        type: InputState.UPDATE_ADDRESS,
        address: addressRestructured,
      });
    } catch (error) {
      history.push(ROUTE_PATH.EVER_GREEN_SINGPASS);
    }
  }

  function onChangeDifrerent(e: any) {
    trackOnFormStartOrSuccess("DS_mailingaddress_form")

    if (addressData.useDifferentMailing === undefined) {
      scrollToUpdateMail();
      dispatchAddressAction({
        type: InputState.UPDATE_ENTIRE_MAILADDRESS,
        useDifferentMailing: true,
      });
    } else {
      if (addressData.useDifferentMailing === true) {
        noChangeMailingAddress();
        dispatchAddressAction({
          type: InputState.UPDATE_ENTIRE_MAILADDRESS,
          useDifferentMailing: false,
        });
      } else {
        scrollToUpdateMail();
        dispatchAddressAction({
          type: InputState.UPDATE_ENTIRE_MAILADDRESS,
          useDifferentMailing: true,
        });
      }
    }
  }

  useEffect(() => {
    if (
      /.{4,10}/.test(addressData.postal) &&
      addressData.street &&
      addressData.country &&
      addressData.block
    ) {
      if (
        addressData.country === "SG" &&
        (isInvalidUnitNo ||
          !addressData.unitNo ||
          !/[0-9]{6}/.test(addressData.postal))
      ) {
        setIsLooksGoodEnabled(false);
        return;
      }
      setIsLooksGoodEnabled(true);
    } else {
      setIsLooksGoodEnabled(false);
    }
  }, [
    addressData.block,
    addressData.country,
    addressData.postal,
    addressData.postal.length,
    addressData.street,
    addressData.unitNo,
    isInvalidUnitNo,
    maxPostCodeLength,
  ]);

  useEffect(() => {
    if (mailingAddress) {
      scrollToUpdateMail();
      dispatchAddressAction({
        type: InputState.UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE,
        mailingaddress: mailingAddress,
      });
    }
  }, [mailingAddress, scrollToUpdateMail]);

  useEffect(() => {
    if (addressData.country && addressData.postal?.length) {
      validatePostCode();
    }
  }, [addressData.country, addressData.postal?.length, validatePostCode]);

  useEffect(()=>{
    if (!isMyInfoSubmitted) return;

    trackOnLoad()
  },[])

  if (!isMyInfoSubmitted) {
    history.push(ROUTE_PATH.EVER_GREEN_MY_INFO);
    return <></>;
  }

  return (
    <>
      <MainContainer
        step={2}
        backButtonPath={`${ROUTE_PATH.EVER_GREEN_MY_INFO}?transaction_id=${myinfotransactionId}`}
      >
        <div ref={mailingAddressOriginalFormRef}>
          <Header>
            Is your residential address the same as your mailing address?
          </Header>
          <Card className={cardStyle} opacityValue="unset">
            <>
              <CardDescription>Residential Address</CardDescription>
              <SpiltUpContainer mariginTop="36px">
                <div>
                  <FieldLable>Block</FieldLable>
                  <FieldValue>{residentialAddress?.block || "-"}</FieldValue>
                </div>
                <div>
                  <FieldLable>Unit Number (If any)</FieldLable>
                  <FieldValue>{residentialAddress?.unitNo || "-"}</FieldValue>
                </div>
              </SpiltUpContainer>
              <SpiltUpContainer mariginTop="44px">
                <div>
                  <FieldLable>Street Name</FieldLable>
                  <FieldValue>{residentialAddress?.street || "-"}</FieldValue>
                </div>
                <div>
                  <FieldLable>Postal Code</FieldLable>
                  <FieldValue>{residentialAddress?.postal || "-"}</FieldValue>
                </div>
              </SpiltUpContainer>
              <SpiltUpContainer mariginTop="44px">
                <div>
                  <FieldLable>Building Name (If any)</FieldLable>
                  <FieldValue>{residentialAddress?.building || "-"}</FieldValue>
                </div>
              </SpiltUpContainer>
            </>
          </Card>
          <UpdateEmailContainer>
            <span className={checkboxDifferentEmail}>
              <Checkbox
                name="diff-mail-address"
                onChange={onChangeDifrerent}
                label="No, I have a different mailing address"
                checked={addressData.useDifferentMailing}
              />
            </span>
            <div className={hideSytle} ref={mailingAddressUpdateFormRef}>
              <Card className={cardStyleUpdateMail}>
                <>
                  <CardDescription>Mailing Address</CardDescription>
                  <SpiltUpContainer mariginTop="28px">
                    <div data-comp="dd" className={countryStyle}>
                      <div>
                        <FieldLable>Country</FieldLable>
                        <>
                          <Dropdown
                            margin={"4px 0 0 0"}
                            source={countryList}
                            placeholder="Select"
                            bindLabel="label"
                            bindId="id"
                            name="nationality"
                            theme={EverGreenStyle}
                            onChange={(e) => {
                            trackOnFormStartOrSuccess("DS_mailingaddress_form")

                              dispatchAddressAction({
                                type: InputState.UPDATE_COUNTRY_CODE,
                                country: e.target.value,
                              });
                            }}
                            value={addressData.country}
                          />
                        </>
                      </div>
                      {addressData.country !== "SG" ? (
                        <div>
                          <FieldLable>Postal Code</FieldLable>
                          <>
                            <Input
                              margin={"13px 0 0 0"}
                              maxLength={maxPostCodeLength}
                              value={addressData.postal}
                              onChange={(e) =>{
                                trackOnFormStartOrSuccess("DS_mailingaddress_form")

                                setPostalCodeValue(e.target.value)}
                              }
                              boxLabel="Postal Code"
                              invalid={!!invalidPostalCode}
                              onBlur={validatePostCode}
                              inputMode={
                                addressData.country === "SG"
                                  ? "numeric"
                                  : "text"
                              }
                              bgColor="transparent"
                              color={EverGreenStyle.colors.primary}
                            />
                            {invalidPostalCode && (
                              <InvalidPostCodeMsg>
                                {invalidPostalCode}
                              </InvalidPostCodeMsg>
                            )}
                          </>
                        </div>
                      ) : null}
                    </div>
                  </SpiltUpContainer>
                  {addressData.country === "SG" ? (
                    <SpiltUpContainer mariginTop="28px">
                      <div className={postalCodeStyle}>
                        <div>
                          <FieldLable>Postal Code</FieldLable>
                          <>
                            <Input
                              margin={"13px 0 0 0"}
                              maxLength={maxPostCodeLength}
                              value={addressData.postal}
                              onChange={(e) =>{
                              trackOnFormStartOrSuccess("DS_mailingaddress_form")
                                setPostalCodeValue(e.target.value)}
                              }
                              boxLabel="Postal Code"
                              invalid={!!invalidPostalCode}
                              onBlur={validatePostCode}
                              inputMode={
                                addressData.country === "SG"
                                  ? "numeric"
                                  : "text"
                              }
                              bgColor="transparent"
                              color={EverGreenStyle.colors.primary}
                            />
                            {invalidPostalCode && (
                              <InvalidPostCodeMsg>
                                {invalidPostalCode}
                              </InvalidPostCodeMsg>
                            )}
                          </>
                        </div>
                        <div>
                          <Button
                            className={searchBtnCss}
                            disabled={
                              !addressData.postal ||
                              addressData.postal.length < 6 ||
                              addressData.country !== "SG"
                            }
                            onClick={() => fetchAddressWithPostalCode()}
                            label="Search"
                            margin={"7px 0px 7px 0px"}
                            bgColor="white"
                            textColor={"#0A544F"}
                            borderColor="#0A544F"
                            height="52px"
                            padding={"16px 24px"}
                          />
                        </div>
                      </div>
                    </SpiltUpContainer>
                  ) : null}
                  <SpiltUpContainer mariginTop="28px">
                    <div className={postalCodeInputStyle}>
                      <div>
                        <FieldLable>Block</FieldLable>
                        <Input
                          margin={"13px 0 0 0"}
                          value={addressData.block}
                          type="alphanumeric"
                          maxLength={30}
                          onChange={(e) => {
                            trackOnFormStartOrSuccess("DS_mailingaddress_form")

                            const value = e.target.value;
                            if (isEmpty(value)) {
                              setIsInValidBlock(true);
                            } else {
                              setIsInValidBlock(false);
                            }
                            dispatchAddressAction({
                              type: InputState.UPDATE_BLOCK_NUMBER,
                              block: e.target.value,
                            });
                          }}
                          boxLabel="Block"
                          bgColor="transparent"
                          color={EverGreenStyle.colors.primary}
                        />
                        {isInValidBlock && (
                          <InvalidPostCodeMsg>
                            Please enter a valid block.
                          </InvalidPostCodeMsg>
                        )}
                      </div>
                      <div>
                        <FieldLable>Street Name</FieldLable>
                        <Input
                          value={addressData.street}
                          type="alphanumeric"
                          maxLength={60}
                          onChange={(e) => {
                            trackOnFormStartOrSuccess("DS_mailingaddress_form")

                            const value = e.target.value;
                            if (isEmpty(value)) {
                              setIsInvalidStreet(true);
                            } else {
                              setIsInvalidStreet(false);
                            }
                            dispatchAddressAction({
                              type: InputState.UPDATE_STREET_NAME,
                              street: e.target.value,
                            });
                          }}
                          margin={"13px 0 0 0"}
                          boxLabel="Street Name"
                          bgColor="transparent"
                          color={EverGreenStyle.colors.primary}
                        />
                        {isInvalidStreet && (
                          <InvalidPostCodeMsg>
                            Please enter a valid street.
                          </InvalidPostCodeMsg>
                        )}
                      </div>
                    </div>
                  </SpiltUpContainer>
                  <SpiltUpContainer mariginTop="28px">
                    <div className={postalCodeInputStyle}>
                      <div className={unitNoCss}>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <FieldLable>Unit Number (If any)</FieldLable>
                          <Tooltip title="Unit Number" isIcon={true}>
                            <ul>
                              <li>
                                For unit number (HDB/condo), enter # followed by
                                numeric digits (e.g. #12-456)
                              </li>
                              <li>
                                For P.O. Box, enter the numeric digits (e.g.
                                12345)
                              </li>
                              <li>
                                For landed property, please input numeral digits (eg. 00-00)
                              </li>
                            </ul>
                          </Tooltip>
                        </label>
                        <Input
                          onChange={(e) => {
                            trackOnFormStartOrSuccess("DS_mailingaddress_form")

                            const value = e.target.value;
                            if (
                              ((/(\d|#|-)/.test(value.slice(-1)) &&
                                addressData.country === "SG") ||
                                (/^([a-z]|[A-Z]|[0-9]|\.|#|\/|\\|-){1,10}$/.test(
                                  value
                                ) &&
                                  addressData.country !== "SG") ||
                                value === "") &&
                              value.length <= 10
                            ) {
                              dispatchAddressAction({
                                type: InputState.UPDATE_UNIT_NUMBER,
                                unitNo: value,
                              });
                              const pattern =
                                /^(#\d{1,3}-\d{1,5})$|(([0]{1}))$|^([0-9]{1,6})-([0-9]{1,6})$/;
                              if (
                                !Validations.isValidUinit(value, pattern) &&
                                addressData.country === "SG"
                              ) {
                                setIsInvalidUnitNo(true);
                              } else if (isInvalidUnitNo) {
                                setIsInvalidUnitNo(false);
                              }
                            }
                          }}
                          invalid={isInvalidUnitNo}
                          value={addressData.unitNo}
                          margin={"13px 0 0 0"}
                          boxLabel="Unit Number"
                          bgColor="transparent"
                          color={EverGreenStyle.colors.primary}
                        />
                        {isInvalidUnitNo && (
                          <InvalidPostCodeMsg>
                            Please enter a valid unit
                          </InvalidPostCodeMsg>
                        )}
                      </div>
                      <div>
                        <FieldLable>Building Name (If any)</FieldLable>
                        <Input
                          type="alphanumeric"
                          maxLength={30}
                          onChange={(e) => {
                            trackOnFormStartOrSuccess("DS_mailingaddress_form")

                            dispatchAddressAction({
                              type: InputState.UPDATE_BUILDING_NAME,
                              building: e.target.value,
                            });
                          }}
                          value={addressData.building}
                          margin={"13px 0 0 0"}
                          boxLabel="Building Name"
                          bgColor="transparent"
                          color={EverGreenStyle.colors.primary}
                        />
                      </div>
                    </div>
                  </SpiltUpContainer>
                  <SpiltUpContainer className={noteText}>
                    <span>
                      If your mailing address differs from your residential
                      address, it will apply only to this policy.
                    </span>
                  </SpiltUpContainer>
                </>
              </Card>
            </div>
          </UpdateEmailContainer>
        </div>
        <ButtonContainer>
          <LooksGoodStyle
            disabled={!isLooksGoodEnabled && addressData.useDifferentMailing}
            onClick={updateMailingAddress}
          >
            Yes, proceed
          </LooksGoodStyle>
        </ButtonContainer>
      </MainContainer>
    </>
  );
}

export default MailingAddress;
